<template>
  <div>
    <div class="title">招聘团队</div>

    <el-tabs style="margin-top: 20px" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="招聘HR" name="first">
        <!-- filter -->
        <div class="filter_box">
          <div class="filter_search">
            <el-input
              class="filter_search_input"
              placeholder="请输入关键词"
              v-model="search.keyword"
              clearable
            >
            </el-input>
            <div class="custom_button no_select" @click="toSearch">搜索</div>
          </div>
          <div class="filter_btns">
            <div class="custom_button plain no_select" @click="addHr">添加招聘HR</div>
          </div>
        </div>

        <!-- table -->
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          style="width: 100%"
        >
          <el-table-column prop="staff.real_name" label="姓名"> </el-table-column>
          <el-table-column prop="staff.mobile" label="手机号码"> </el-table-column>
          <el-table-column prop="serial" label="绑定微信"> </el-table-column>
          <el-table-column prop="job_list" label="参与招聘职位">
            <template v-slot:default="scope">
              {{ scope.row.job_list.map((item) => item.name).join("，") }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot:default="scope">
              <div class="operations">
                <div @click="editHr(scope.row)">编辑</div>
                <div @click="del(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="面试官" name="second">
        <!-- filter -->
        <div class="filter_box">
          <div class="filter_search">
            <el-input
              class="filter_search_input"
              placeholder="请输入关键词"
              v-model="search.keyword"
              clearable
            >
            </el-input>
            <div class="custom_button no_select" @click="toSearch">搜索</div>
          </div>
          <div class="filter_btns">
            <div class="custom_button plain no_select" @click="addInterviewer">
              添加面试官
            </div>
          </div>
        </div>

        <!-- table -->
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          style="width: 100%"
        >
          <el-table-column prop="staff.real_name" label="姓名"> </el-table-column>
          <el-table-column prop="staff.department_data.department_name" label="子公司">
          </el-table-column>
          <el-table-column prop="staff.department_data.station_name" label="岗位">
          </el-table-column>
          <el-table-column prop="staff.mobile" label="手机号码"> </el-table-column>
          <el-table-column prop="staff.email" label="邮箱"> </el-table-column>
          <el-table-column prop="serial" label="员工端"> </el-table-column>
          <el-table-column prop="job_list" label="参与招聘职位">
            <template v-slot:default="scope">
              {{ scope.row.job_list.map((item) => item.name).join("，") }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot:default="scope">
              <div class="operations">
                <div @click="editInterviewer(scope.row)">编辑</div>
                <div @click="del(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-pagination
      layout="prev, pager, next"
      :total="page.total"
      :page-size="page.size"
      :current-page.sync="page.page"
      @current-change="getPageCurrent"
    >
    </el-pagination>

    <el-dialog
      :title="(form.id ? '编辑' : '添加') + (form.type == 1 ? 'HR' : '面试官')"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="员工名称" prop="staff_id" v-if="!form.id">
          <el-select
            v-model="form.staff_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入面员工姓名搜索"
            :remote-method="remoteMethod"
            :loading="employee_loading"
          >
            <el-option
              v-for="item in employee_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择招聘岗位：" prop="job_ids_list">
          <el-select v-model="form.job_ids_list" multiple placeholder="请选择">
            <el-option
              v-for="item in job_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="custom_button no_select" @click="submit">确 定</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      activeName: "first",
      search: {
        keyword: "",
      },
      page: {
        size: 15,
        page: 1,
        total: 0,
      },
      tableData: [],
      dialogVisible: false,
      employee_options: [],
      employee_loading: false,
      form: {
        id: "",
        staff_id: "",
        job_ids: "",
        job_ids_list: "",
        type: "",
      },
      rules: {
        staff_id: [
          {
            required: true,
            message: "请选择员工",
            trigger: "blur",
          },
        ],
        job_ids_list: [
          {
            required: true,
            message: "请选择至少一项岗位",
            trigger: "blur",
          },
        ],
      },

      tableHeaderStyle: {
        backgroundColor: "#F5F8FA",
        textAlign: "center",
      },
      tableCellStyle: {
        textAlign: "center",
      },
      job_options: [],
    };
  },
  created() {
    this.loadData();

    this.getStationList()
      .then((res) => {
        console.log(res);
        this.job_options = res.data.data.list;
      })
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    ...mapActions("employee", ["getEmployeeList", "getStationList"]),
    ...mapActions("recruitment", [
      "getJobTeam",
      "addJobTeammate",
      "editJobTeammate",
      "delJobTeammate",
    ]),

    remoteMethod(query) {
      if (query !== "") {
        this.employee_loading = true;
        this.getEmployeeList({
          page: 1,
          keywords: query,
          status: 3,
        })
          .then((res) => {
            this.employee_loading = false;
            console.log(res);
            this.employee_options = res.data.data.list.map((item) => {
              return {
                label: item.real_name,
                value: item.id,
              };
            });
          })
          .catch((e) => {
            this.employee_loading = false;
            console.error(e);
          });
      } else {
        this.employee_options = [];
      }
    },

    addHr() {
      this.form = {
        id: "",
        staff_id: "",
        job_ids: "",
        job_ids_list: "",
        type: 1,
      };
      this.dialogVisible = true;
    },

    editHr(row) {
      this.form = {
        id: row.id,
        staff_id: row.staff_id,
        job_ids: row.job_ids,
        job_ids_list: row.job_ids.split(",").map((item) => Number(item)),
        type: 1,
      };
      this.dialogVisible = true;
    },

    addInterviewer() {
      this.form = {
        id: "",
        staff_id: "",
        job_ids: "",
        job_ids_list: "",
        type: 2,
      };
      this.dialogVisible = true;
    },

    editInterviewer(row) {
      this.form = {
        id: row.id,
        staff_id: row.staff_id,
        job_ids: row.job_ids,
        job_ids_list: row.job_ids.split(",").map((item) => Number(item)),
        type: 2,
      };
      this.dialogVisible = true;
    },

    del(row) {
      this.$confirm("此操作将永久删除该条目, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.delJobTeammate({ id: row.id })
          .then((res) => {
            console.log(res);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.loadData();
          })
          .catch((e) => {
            console.error(e);
            this.$message({
              type: "error",
              message: e.msg,
            });
          });
      });
    },

    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let loading = this.$loading();
          this.dialogVisible = false;

          this.form.job_ids = this.form.job_ids_list.join(",");

          if (this.form.id) {
            // 编辑
            this.editJobTeammate(this.form)
              .then((res) => {
                console.log(res);
                loading.close();
                this.$message.success(res.data.msg);
                this.loadData();
              })
              .catch((e) => {
                console.log(e);
                loading.close();
                this.$message.error(e.msg);
              });
          } else {
            // 添加
            this.addJobTeammate(this.form)
              .then((res) => {
                console.log(res);
                loading.close();
                this.$message.success(res.data.msg);
                this.loadData();
              })
              .catch((e) => {
                console.log(e);
                loading.close();
                this.$message.error(e.msg);
              });
          }
        } else {
          this.$notify.error({
            title: "提交失败",
            message: "请先完整填写表单",
          });
          return false;
        }
      });
    },

    loadData(func) {
      // 单例初始化
      if (!this.loadDataObj) this.loadDataObj = new LoadDataClass(1, this.getJobTeam);

      // 通知，用于修改对象属性
      if (func) func(this.loadDataObj);

      let loading = this.$loading();
      //   .load(this.page.page)
      this.loadDataObj
        .load(this.page.page, this.page.size)
        .then((res) => {
          console.log(res, "列表数组");
          this.tableData = res.data.data.list;
          this.page.total = res.data.data.total;
          loading.close();
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e);
        });
    },

    // 分页
    getPageCurrent(e) {
      console.log("分页", e);
      this.page.page = e;
      this.loadData();
    },

    /**
     * 搜索
     */
    toSearch() {
      this.page.page = 1;
      this.loadData((loadDataObj) => {
        loadDataObj.keyword = this.search.keyword;
      });
    },

    handleClick(tab, event) {
      console.log(tab, event);
      this.page.page = 1;
      this.loadData((loadDataObj) => {
        loadDataObj.type = Number(tab.index) + 1;
      });
    },
  },
};

class LoadDataClass {
  constructor(type, getJobTeam, keyword = null) {
    this.type = type;
    this.func = getJobTeam;
    this.keyword = keyword;
  }

  load(page, size) {
    console.log("loadpage", page);
    let params = {
      page,
      size,
      type: this.type,
    };
    if (this.keyword) params.keywords = this.keyword;
    return this.func(params);
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
  font-weight: bold;
  color: #1c2438;
}

.filter_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0;

  .filter_search {
    display: flex;
    align-items: center;

    .filter_search_input {
      width: 680px;
      height: 36px;
      margin-right: 10px;

      ::v-deep .el-input__inner {
        height: 36px;
      }
    }
  }

  .filter_btns {
    display: flex;
    align-items: center;

    > div:not(:first-child) {
      margin-left: 20px;
    }
  }
}

.el-tabs {
  ::v-deep .el-tabs__header {
    margin: 0;
  }

  ::v-deep .el-tabs__item {
    font-size: 16px;
    color: #495060;
    height: 45px;

    &.is-active {
      color: #4db9d5;
    }
  }

  ::v-deep .el-tabs__active-bar {
    background-color: #4db9d5;
  }
}

.operations {
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    font-size: 14px;
    color: #406bff;
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 13px;
    }
  }
}
</style>
